require('../../modules/es6.math.imul');
module.exports = require('../../modules/_core').Math.imul;



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/fn/math/imul.js
// module id = acwh
// module chunks = 0